module.exports = __webpack_public_path__ + "static/media/Circe-ExtraBold.7e553a6c.otf";